(function () {
  'use strict';

  function pad2(n) {
    var v = Math.max(0, Math.min(99, Math.floor(n)));
    return (v < 10 ? '0' : '') + v;
  }

  /**
   * Strict parse: rejects invalid calendar dates (e.g. 2026-06-31).
   * Uses visitor local timezone for YYYY-MM-DDTHH:mm:ss without Z.
   */
  function parseEnd(raw) {
    if (!raw || !String(raw).trim()) return null;

    var s = String(raw).trim().replace(' ', 'T');
    var iso = s.match(
      /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2})(?::(\d{2}))?)?$/
    );

    if (iso) {
      var y = parseInt(iso[1], 10);
      var mo = parseInt(iso[2], 10) - 1;
      var d = parseInt(iso[3], 10);
      var h = parseInt(iso[4] || '23', 10);
      var mi = parseInt(iso[5] || '59', 10);
      var sec = parseInt(iso[6] || '59', 10);
      var dt = new Date(y, mo, d, h, mi, sec);

      if (
        dt.getFullYear() !== y ||
        dt.getMonth() !== mo ||
        dt.getDate() !== d
      ) {
        return null;
      }

      return dt.getTime();
    }

    var t = Date.parse(s);
    return Number.isNaN(t) ? null : t;
  }

  function tick(root) {
    var raw = root.getAttribute('data-end');
    var end = parseEnd(raw);
    var digits = root.querySelectorAll('.mooka-countdown__digit');
    var expiredEl = root.querySelector('[data-countdown-expired]');
    var invalidEl = root.querySelector('[data-countdown-invalid]');
    var hideExpired = root.getAttribute('data-hide-expired') === 'true';

    function clearStates() {
      root.removeAttribute('data-state');
      if (expiredEl) expiredEl.hidden = true;
      if (invalidEl) invalidEl.hidden = true;
    }

    if (!end) {
      root.setAttribute('data-state', 'invalid');
      digits.forEach(function (el) {
        el.textContent = '-';
      });
      if (invalidEl) invalidEl.hidden = false;
      return;
    }

    if (digits.length !== 8) return;

    var ms = end - Date.now();
    if (ms <= 0) {
      root.setAttribute('data-state', 'expired');
      digits.forEach(function (el) {
        el.textContent = '0';
      });
      if (expiredEl) expiredEl.hidden = false;
      return;
    }

    clearStates();

    var totalSec = Math.floor(ms / 1000);
    var days = Math.floor(totalSec / 86400);
    var rem = totalSec % 86400;
    var hours = Math.floor(rem / 3600);
    rem = rem % 3600;
    var minutes = Math.floor(rem / 60);
    var seconds = rem % 60;
    var chars = (
      pad2(days) + pad2(hours) + pad2(minutes) + pad2(seconds)
    ).split('');

    digits.forEach(function (el, i) {
      el.textContent = chars[i] || '0';
    });
  }

  function init() {
    document.querySelectorAll('[data-mooka-countdown]').forEach(tick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setInterval(init, 1000);
  document.addEventListener('shopify:section:load', init);
})();
